var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"content-card"},[_c('page-header',{attrs:{"title":"Pronóstico Comercial"},on:{"back":_vm.volverAtras}}),_c('FiltrosOfertas',{on:{"filtrar":_vm.filtrosCambiados}}),_c('GraficaActividadPendientes',{attrs:{"items":_vm.items}}),_c('TablaPronosticoComercial',{attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }